import type { DailyCloseProductHead, DailyCloseProductItem } from '@/services/inventory/dailyCloseProduct/types'
import { DailyCloseSplitTables, type DailyCloseTablesProps } from '../../dailyCloseShared/DailyCloseSplitTables'
import { HEAD_COLUMNS, ITEM_COLUMNS } from './columnDefinitions'

export function DailyCloseProductTables(props: Readonly<DailyCloseTablesProps<DailyCloseProductHead, DailyCloseProductItem>>) {
  return <DailyCloseSplitTables<DailyCloseProductHead, DailyCloseProductItem> {...props} headColumns={HEAD_COLUMNS} itemColumns={ITEM_COLUMNS} />
}
